module.exports = __webpack_public_path__ + "static/img/card_4_1.1965950.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_4_1.png
// module id = YuDL
// module chunks = 0